import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './desktopPairing.style';
import { displaySteps, getSteps, makeKeys, makePatch } from '../pairing.utils';
import { SELECTED_SIGNAL } from '../../signals';

export class DesktopPairing extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  _inactive() {
    this.tag('Code').removeAllListeners('txLoaded');
    this._token = null;
  }

  set labels(value) {
    this.tag('Title').text.text = value.title;

    if (value.stepsCount && value.steps) {
      displaySteps(getSteps(this, 5), makeKeys(value.steps, value.stepsCount));
    }
  }

  set steps(value) {
    if (!value) {
      return;
    }

    displaySteps(getSteps(this, 5), value);
  }

  set button(value) {
    this.tag('Button').patch({
      label: value,
      visible: Boolean(value),
    });

    this._refocus();
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    // WARN: only static values are supported
    this.patch({
      Title: {
        text: {
          wordWrapWidth: value,
        },
      },
      ...makePatch(5, { w: value }),
    });
  }

  set token(value) {
    if (value === this._token) {
      return;
    }

    this.tag('Code').text.text = value ? value.split('').join('  ') : '';
  }

  _handleEnter() {
    if (!this.tag('Button').visible) {
      return false;
    }

    this.signal(SELECTED_SIGNAL);

    return true;
  }

  _getFocused() {
    const button = this.tag('Button');

    return button.visible ? button : undefined;
  }
}
